export const buttonSize = {
  ExtraLarge: 'extra-large',
  Large: 'large',
  Small: 'small',
  Tiny: 'tiny'
} as const;

export const buttonVariant = {
  Casino: 'casino',
  CasinoGlass: 'casino-glass',
  Filter: 'filter',
  Form: 'form',
  Legacy: 'legacy',
  Primary: 'primary',
  Secondary: 'secondary',
  Tertiary: 'tertiary',
  Text: 'text'
} as const;

export type ButtonSize = (typeof buttonSize)[keyof typeof buttonSize];
export type ButtonVariant = (typeof buttonVariant)[keyof typeof buttonVariant];
